<div class="tile" *ngIf="salesOrganisation">
  <div class="header">
    <div class="title">{{ 'DASHBOARD.LOCAL_OFFICE.TITLE' | translate }}</div>
  </div>
  <div class="body">
    <div class="data" *ngFor="let contact of salesOrganisation.contacts" [ngClass]="{double: salesOrganisation.contacts.length <= 2}">
      <app-contact [contact]="contact"></app-contact>
    </div>
  </div>
</div>
